const Link = dynamic(() => import('next/link'));
import Image from 'next/image';
import {
  ProSidebar,
  Menu,
  MenuItem,
  SubMenu,
  SidebarContent,
  SidebarFooter
} from 'react-pro-sidebar';
import 'react-pro-sidebar/dist/css/styles.css';
import styled from 'styled-components';
import FaceBookIcon from '../assets/svg/aifillfb.svg';
// import TwitterIcon from '../assets/svg/aifilltwittersquare.svg';
// import InstagramIcon from '../assets/svg/fainstagramsquare.svg';
// import YoutubeIcon from '../assets/svg/fayoutubesquare.svg';
import dynamic from 'next/dynamic';
import { useAuthContext } from '../../utils/context/authContext';
import { useRouter } from 'next/router';

interface IProps {
  isOpen: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setOpenMyTours: React.Dispatch<React.SetStateAction<boolean>>;
}
interface ParentDiv {
  open: boolean;
}
const Parent_Div = styled.div<ParentDiv>`
  body {
    overflow: ${props => (props.open ? 'hidden ' : 'scroll')}!important;
  }
`;
const SideNav_Wrapper = styled.div`
  .pro-sidebar {
    height: calc(100vh - 62px);
    position: fixed;
    transition: width, left, right, 0.3s;

    .pro-sidebar-layout {
      ul {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
      }
    }

    .pro-menu {
      height: 100%;
      padding-bottom: 25px;
    }
  }
  .pro-sidebar-inner {
    background: #1f2c5b;
    .pro-sidebar-content {
      margin-left: 20px;
      border-bottom: 1px solid hsla(0, 0%, 100%, 0.2);
      .pro-menu {
        a {
          color: #fffdfd;
        }
        a:hover {
          color: #d9d9d9;
        }
        a::before {
          content: none;
        }
        .pro-menu-item {
          font-size: 1.4rem;
        }
        .pro-menu-item:hover {
          background-color: #423dd6;
        }
      }
    }
    .pro-sidebar-footer {
      .pro-menu {
        .pro-menu-item {
          .pro-inner-item {
            padding: 10px 20px;
            .pro-item-content {
              display: flex;
              justify-content: center;
              gap: 13px;

              a::before {
                content: none;
              }

              svg {
                font-size: 20px;
                color: white;
              }
              svg:hover {
                color: #d9d6d6;
              }
            }
          }
        }
      }
    }
  }
`;
const SideNav = ({ isOpen, setOpen, setOpenMyTours }: IProps) => {
  const { user, handleLogout }: any = useAuthContext();
  const router = useRouter();

  return (
    <Parent_Div
      id="nav-overlay"
      className={
        !isOpen
          ? 'hidden'
          : 'h-[100vh] w-[100%] bg-black  bg-opacity-40   fixed min-h-screen top-[63px] md:top-[70px]  left-0'
      }
      onClick={() => setOpen(false)}
      open={isOpen}
    >
      <SideNav_Wrapper className="left-0">
        <ProSidebar collapsed={!isOpen}>
          <SidebarContent>
            <Menu>
              <Link href="/" onClick={() => setOpen(true)}>
                <MenuItem className="">Home</MenuItem>
              </Link>
              <Link href="/tours" onClick={() => setOpen(true)}>
                <MenuItem className="py-1">Day Tours</MenuItem>
              </Link>
              <Link href="/private-tours" onClick={() => setOpen(true)}>
                <MenuItem className="py-1">Private Tours</MenuItem>
              </Link>
              <Link href="/cities" onClick={() => setOpen(true)}>
                <MenuItem className="py-1">Cities</MenuItem>
              </Link>
              <Link href="/guides" onClick={() => setOpen(true)}>
                <MenuItem className="py-1">Guides</MenuItem>
              </Link>
              <Link href="/reviews" onClick={() => setOpen(true)}>
                <MenuItem className="py-1">Reviews</MenuItem>
              </Link>
              <Link href="/about-us" onClick={() => setOpen(true)}>
                <MenuItem className="py-1">About Us</MenuItem>
              </Link>

              <Link href="/ambassador" onClick={() => setOpen(true)}>
                <MenuItem className="py-1">Ambassador</MenuItem>
              </Link>
              <Link href="/public-relations" onClick={() => setOpen(true)}>
                <MenuItem className="py-1">Public Relations</MenuItem>
              </Link>
              <span
                onClick={() => {
                  setOpenMyTours(true);
                  setOpen(true);
                }}
                className="text-white"
              >
                <MenuItem className="">My Tours</MenuItem>
              </span>

              <MenuItem
                onClick={() => {
                  user ? handleLogout() : router.push('/signin');
                  setOpen(false);
                }}
                className="text-white"
              >
                {user && user.emailVerified ? 'Log Out' : 'Sign In'}
              </MenuItem>

              {user && user.emailVerified && (
                <Link href="/accounts" onClick={() => setOpen(false)}>
                  <MenuItem className="text-white py-1">Account</MenuItem>
                </Link>
              )}
            </Menu>
          </SidebarContent>
          <SidebarFooter>
            <Menu iconShape="circle">
              <MenuItem>
                <a
                  href="https://www.facebook.com/NiagaraFallsTours"
                  target="_blank"
                  rel="noreferrer noopener"
                  aria-label="This is an external link (opens in a new tab)"
                  className="inline"
                >
                  <Image
                    src={
                      'https://res.cloudinary.com/see-sight-tours/image/upload/v1686740252/Remaining%20images/Footer/fb_ncxnkv.svg'
                    }
                    width={35}
                    height={30}
                    alt="https://www.facebook.com/NiagaraFallsTours"
                  />
                  {/* <FaceBookIcon /> */}
                </a>
                <a
                  href="https://www.youtube.com/user/SeeSightTours"
                  target="_blank"
                  rel="noreferrer noopener"
                  aria-label="This is an external link (opens in a new tab)"
                >
                  <Image
                    src={
                      'https://res.cloudinary.com/see-sight-tours/image/upload/v1686740252/Remaining%20images/Footer/youtubes_nubcep.svg'
                    }
                    width={35}
                    height={30}
                    alt="https://www.youtube.com/user/SeeSightTours"
                  />
                  {/* <YoutubeIcon /> */}
                </a>
                <a
                  href="https://www.instagram.com/seesighttours/"
                  target="_blank"
                  rel="noreferrer noopener"
                  aria-label="This is an external link (opens in a new tab)"
                >
                  <Image
                    src={
                      'https://res.cloudinary.com/see-sight-tours/image/upload/v1686740252/Remaining%20images/Footer/insta_lx84yb.svg'
                    }
                    width={35}
                    height={30}
                    alt="https://www.instagram.com/seesighttours/"
                  />
                  {/* <InstagramIcon /> */}
                </a>

                <a
                  href="https://twitter.com/seesighttours?lang=en"
                  target="_blank"
                  rel="noreferrer noopener"
                  aria-label="This is an external link (opens in a new tab)"
                >
                  <Image
                    src={
                      'https://res.cloudinary.com/see-sight-tours/image/upload/v1686740252/Remaining%20images/Footer/ltwitter_ymqtzy.svg'
                    }
                    width={35}
                    height={30}
                    alt="https://twitter.com/seesighttours?lang=en"
                  />
                  {/* <TwitterIcon /> */}
                </a>
              </MenuItem>
            </Menu>
          </SidebarFooter>
        </ProSidebar>
      </SideNav_Wrapper>
    </Parent_Div>
  );
};

export default SideNav;
